const scripts: Record<string, Promise<void>> = {};

type LoadScriptOptions = {
  async?: boolean;
  defer?: boolean;
};

function createScriptTag(
  src: string,
  options: LoadScriptOptions,
  resolve: () => void,
  reject: (reason: string) => void,
) {
  const script = document.createElement("script");
  script.src = src;
  script.onload = () => resolve();
  script.onerror = () => reject(`Error loading script ${src}`);
  if (options.defer) {
    script.defer = true;
  } else if (options.async !== false) {
    script.async = true;
  }

  document.head.appendChild(script);
}

export default function loadScript(
  src: string,
  options: LoadScriptOptions = { async: true },
): Promise<void> {
  if (!scripts[src]) {
    scripts[src] = new Promise((resolve, reject) => {
      createScriptTag(src, options, resolve, reject);
    });
  }
  return scripts[src];
}
